import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          // handle HTTP errors
          switch (error.status) {
            case 401:
              console.log('Error 402!');
              break;
            case 403:
              console.log('Error 403!');
              break;
            default:
              console.log(error);
          }
        }
        // need to rethrow so angular can catch the error
        return throwError(error);
      }),
    );
  }
}
